import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../../../src/components/ui/dialog';
import { GovernanceGlossary } from './GovernanceGlossary';

interface GovernanceGlossaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialTerm?: string;
}

export function GovernanceGlossaryModal({
  isOpen,
  onClose,
  initialTerm,
}: GovernanceGlossaryModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Governance Terms & Definitions</DialogTitle>
        </DialogHeader>
        <GovernanceGlossary isModal={true} onClose={onClose} initialTerm={initialTerm} />
      </DialogContent>
    </Dialog>
  );
}
